<template>
  <div class="home pb-5 pt-2 container" id="insights-dashboard">
    <static-alert v-if="errors" :message="errors" @on-hide="errors=''" />

    <div class="d-flex align-items-start flex-wrap">
      <h1 class="me-2">Insights</h1>

      <div class="d-flex ms-auto mb-4">
        <div class="ms-auto">
          <date-preset-selector v-model="range" />
        </div>
      </div>
    </div>


    <ul class="nav nav-tabs nav-justified mb-4">
      <li class="nav-item" v-for="v in views" :key="v.value">
        <router-link class="nav-link" :to="{'name': v.value}" :class="{active:$route.matched.some(r => r.name === v.value)}">{{ v.label }}</router-link>
      </li>
    </ul>


    <div style="min-height: 100vh">
      <router-view v-slot="{ Component }">
        <transition mode="out-in">
          <component :is="Component" :range="range"  @reset-date="resetDate" />
        </transition>
      </router-view>
    </div>

    <div class="p-5"></div>

  </div>
</template>

<script setup>

import {ref, watch} from 'vue'
import { useStore } from 'vuex'
import StaticAlert from "@/app/components/Utils/StaticAlert.vue";
import DatePresetSelector from "@/app/components/Utils/DatePresetSelector.vue";

const errors = ref('')
const store = useStore()
const viewName = ref('overview')

// Initialize range from Vuex getter (returns stored range or default LAST_7_DAYS)
const range = ref({ ...store.getters['eshop/lastDateRange'] })

// const viewLabel = computed(() => {
//   const label = views.find(v => v.value === viewName.value)
//   console.log(label)
//   return label ? label.label : 'Insights'
// })

const views = [
  {label: 'Overview', value: 'InsightsOverview'},
  {label: 'Sales', value: 'InsightsSales'},
  {label: 'Speed', value: 'InsightsSpeed'},
  {label: 'Health', value: 'InsightsHealth'},
]

watch(range, () => {
  rangeChange()
})

function resetDate() {
  store.commit('eshop/setLastDateRange', null)
  range.value = { ...store.getters['eshop/lastDateRange'] }
}

function rangeChange() {
  fetch('/api/events', {
    method: 'POST',
    keepalive: true,
    body: JSON.stringify({
      event_type: 'date_range_changed',
      context: `Insights ${viewName.value}`,
      ts: Date.now()
    })
  });
}



</script>

<style lang="scss" scoped>
.chart-container { max-width: 500px; margin:0 auto;}
.nav.nav-tabs.nav-justified .nav-link.active { font-weight: bold; }
@media (max-width: 768px) {
  .nav.nav-tabs.nav-justified .nav-link {
    padding: 0.4rem 0.5rem;
    font-size: 0.8rem;
    white-space: nowrap;
  }
}
</style>
